import { useCallback } from 'react';
import { bridge } from '../../../../../utils';
import type { IScreensLogging } from '../../../../../api/types';

type BannerItem = {
  deeplink: string;
  logging: IScreensLogging;
  thumbnail: string;
  thumbnail_ratio: number;
};

/**
 * GoodsCarousel 배너 클릭 로깅.
 * 네비게이션(openDeeplink)은 호출부에서 분리해서 처리.
 */
export const useLogClickBanner = (
  banner: BannerItem | null,
  componentLogging: IScreensLogging | undefined,
) => {
  return useCallback(() => {
    if (!banner) return;
    bridge.logAnalyticsEvent({
      name: 'CLICK_BANNER',
      analytics: {
        ...componentLogging?.analytics,
        ...banner.logging.analytics,
      },
      ably_only_log: {
        ...componentLogging?.ably_only_log,
        ...banner.logging.ably_only_log,
      },
    });
  }, [banner, componentLogging]);
};
